export enum InvestorsCellBlock {
  Root = 'InvestorsCell',
}
